
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...custom]",
      function () {
        return require("private-next-pages/[...custom].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...custom]"])
      });
    }
  